import { CheckCircle } from "@phosphor-icons/react";
import { fmtBRL } from "../lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const OrderCreatedDialog = ({ info, onClose, type = "order" }) => {
  if (!info) return null;
  const isOrder = type === "order";
  const label = isOrder ? "Pedido" : "Orçamento";
  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent data-testid={`${type}-created-dialog`} className="bg-zinc-900 border-zinc-800 text-zinc-50 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2 text-emerald-400">
            <CheckCircle size={26} weight="fill" />
            {label} #{info.code} criado com sucesso
          </DialogTitle>
          <DialogDescription className="text-zinc-400">
            {info.already_existed
              ? `Este ${label.toLowerCase()} já havia sido salvo anteriormente — uma duplicata foi evitada automaticamente.`
              : isOrder
                ? "O pedido foi registrado e as parcelas foram geradas no financeiro."
                : "O orçamento foi registrado — sem lançamentos no financeiro. Converta em pedido quando o cliente aprovar."}
          </DialogDescription>
        </DialogHeader>
        <div className="border border-zinc-800 rounded-lg divide-y divide-zinc-800/60 text-sm">
          <div className="flex justify-between px-4 py-2.5">
            <span className="text-zinc-500">Cliente</span>
            <span data-testid={`${type}-created-client`} className="text-zinc-200 font-medium">{info.client_name}</span>
          </div>
          <div className="flex justify-between px-4 py-2.5">
            <span className="text-zinc-500">Valor Total</span>
            <span data-testid={`${type}-created-total`} className="font-display font-semibold text-emerald-400">{fmtBRL(info.total_value)}</span>
          </div>
          <div className="flex justify-between px-4 py-2.5">
            <span className="text-zinc-500">{isOrder ? "Parcelas" : "Parcelas (previsão)"}</span>
            <span className="text-zinc-200">{info.installments}x</span>
          </div>
          {info.credit_applied > 0 && (
            <div className="flex justify-between px-4 py-2.5">
              <span className="text-zinc-500">Crédito abatido</span>
              <span data-testid={`${type}-created-credit`} className="text-emerald-400">{fmtBRL(info.credit_applied)}</span>
            </div>
          )}
        </div>
        <button data-testid={`${type}-created-ok-button`} onClick={onClose} autoFocus
          className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-medium py-3 rounded-lg transition-colors">
          OK, entendi
        </button>
      </DialogContent>
    </Dialog>
  );
};
